export default __webpack_public_path__ + "1ccc91d66198ee5f3d12f04cc9738ad0.png";